import { getGroupKeywordsEditorId } from '../service/keywordsEditor';
import { GroupId } from '../typings/groups';
import { getEditGroupDataValueWithKeywords } from '../typings/groupsEditState';
import { KeywordsData, KeywordsEditorData } from '../typings/keywordsEditorData';
import { State } from '../typings/state';

import { selectEditGroupValueInfo } from './groupEdit/group/group';

export const selectKeywordsEditorData = (state: State, editorId: string): KeywordsEditorData =>
    state.keywordsEditor.editors[editorId];

const defaultKeywords: KeywordsData[] = [];

export const selectEditGroupCurrentKeywords = (state: State, groupId: GroupId): KeywordsData[] => {
    const editor = selectKeywordsEditorData(state, getGroupKeywordsEditorId(groupId));

    if (editor && editor.isOpen) {
        return editor.value;
    }

    const groupDataValue = getEditGroupDataValueWithKeywords(selectEditGroupValueInfo(state, groupId));

    return (groupDataValue && groupDataValue.keywords) || defaultKeywords;
};
